import { TextInput, TextArea, Switch } from '@soteria/design-system-ve';

import type { DialogPolicyInfo } from '../../types';
import { useDialogContext } from '../DialogProvider';

import * as styles from './Steps.css';

/**
 * PolicyInfoStep component - Step 1 of the dialog
 * Handles policy name, description, and enabled status
 */
export function PolicyInfoStep() {
  const { state, actions } = useDialogContext();
  const { policyInfo } = state.formData;

  const handleFieldChange = <K extends keyof DialogPolicyInfo>(field: K, value: DialogPolicyInfo[K]) => {
    actions.updateFormData({
      policyInfo: {
        ...policyInfo,
        [field]: value,
      },
    });
  };

  return (
    <div className={styles.stepFormStyles}>
      <div className={styles.inputGroupStyles}>
        <TextInput
          required
          id="policyName"
          label="Policy Name"
          placeholder="Enter policy name"
          value={policyInfo.name}
          onChange={value => handleFieldChange('name', value)}
        />
      </div>

      <div className={styles.inputGroupStyles}>
        <TextArea
          id="policyDescription"
          placeholder="Enter policy description (optional)"
          title="Description"
          value={policyInfo.description}
          onChange={e => handleFieldChange('description', e.target.value)}
        />
      </div>

      <div className={styles.switchGroupStyles}>
        <div className={styles.switchContainerStyles}>
          <div>
            <h4 className={styles.switchLabelStyles} id="policy-enabled-label">
              Enable Policy
            </h4>
            <p className={styles.switchDescriptionStyles} id="policy-enabled-description">
              When enabled, this policy will actively monitor and flag content according to the configured rules. When disabled, the policy will not be applied
              to any content.
            </p>
          </div>
          <Switch
            checked={policyInfo.isEnabled}
            id="isPolicyEnabled"
            inputProps={{
              'aria-labelledby': 'policy-enabled-label',
              'aria-describedby': 'policy-enabled-description',
            }}
            stateChangeAnnouncement={(checked: boolean) =>
              `Policy is now ${checked ? 'enabled and will actively monitor content' : 'disabled and will not monitor content'}`
            }
            onChange={checked => handleFieldChange('isEnabled', checked)}
          />
        </div>
      </div>
    </div>
  );
}
